import { Injectable } from '@angular/core';

import { FailedCartTicket, RidangoReduxAction, ShoppingCart, Ticket } from '@ridango/core';


@Injectable({
    providedIn: 'root',
})
export class ShoppingCartActionsV2 {
    static POST_TICKET_PAYLOADS = '[Shopping Cart Purchase] Post Ticket Payloads';
    static POST_TICKET_PAYLOADS_SUCCESS = '[Shopping Cart Purchase] Post Ticket Payloads Success';
    static POST_TICKET_PAYLOADS_FAILED = '[Shopping Cart Purchase] Post Ticket Payloads Failed';

    static FETCH_CART_CONTENTS = '[Shopping Cart Purchase] Fetch Cart Contents';

    static DELETE_SHOPPING_CART = '[ShoppingCart] Delete shopping cart';

    static DELETE_TICKET_FROM_CART = '[ShoppingCart] Delete ticket from cart';

    static REMOVE_TICKET_FROM_CART = '[ShoppingCart] Remove ticket from cart';
    static REMOVE_TICKET_FROM_CART_FAILED = '[ShoppingCart] Remove ticket from cart Failed';

    static UPDATE_CART_TOTAL_PRICE = '[ShoppingCart] Update cart price';

    static SET_CART_TERMS_AGREED = '[ShoppingCart] Set terms agreed';

    static SET_CART_STATUS = '[ShoppingCart] Set status';

    static HYDRATE_CART_STATE = '[ShoppingCart] Hydrate cart state';

    static SET_IN_WEB_PAYMENT_SELECTED = '[ShoppingCart] Set in web payment selected';

    postTicketPayloads(payload: any[]): RidangoReduxAction {
        return {
            type: ShoppingCartActionsV2.POST_TICKET_PAYLOADS,
            payload: payload,
        };
    }

    postTicketPayloadsSuccess(payload: any): RidangoReduxAction {
        return {
            type: ShoppingCartActionsV2.POST_TICKET_PAYLOADS_SUCCESS,
            payload: payload,
        };
    }

    postTicketPayloadsFailed(payload: FailedCartTicket[]): RidangoReduxAction {
        return {
            type: ShoppingCartActionsV2.POST_TICKET_PAYLOADS_FAILED,
            payload: payload,
        };
    }

    fetchCartContents(payload: any): RidangoReduxAction {
        return {
            type: ShoppingCartActionsV2.FETCH_CART_CONTENTS,
            payload: payload,
        };
    }

    deleteCart(): RidangoReduxAction {
        return {
            type: ShoppingCartActionsV2.DELETE_SHOPPING_CART,
        };
    }

    deleteTicketFromCart(ticket: Ticket, cart: ShoppingCart): RidangoReduxAction {
        return {
            type: ShoppingCartActionsV2.DELETE_TICKET_FROM_CART,
            payload: { ticket: ticket, cart: cart },
        };
    }

    removeTicketFromCart(ticket: Ticket, cart: ShoppingCart): RidangoReduxAction {
        return {
            type: ShoppingCartActionsV2.REMOVE_TICKET_FROM_CART,
            payload: { ticket: ticket, cart: cart },
        };
    }

    removeTicketFromCartFailed(payload: any): RidangoReduxAction {
        return {
            type: ShoppingCartActionsV2.REMOVE_TICKET_FROM_CART_FAILED,
            payload: payload,
        };
    }

    updateCartTotalPrice(payload: any): RidangoReduxAction {
        return {
            type: ShoppingCartActionsV2.UPDATE_CART_TOTAL_PRICE,
            payload: payload,
        };
    }

    setInWebPaymentSelected(inWebPaymentSelected: boolean): RidangoReduxAction {
        return {
            type: ShoppingCartActionsV2.SET_IN_WEB_PAYMENT_SELECTED,
            payload: { inWebPaymentSelected: inWebPaymentSelected },
        };
    }

    setCartTermsAgreed(termsAgreed: boolean): RidangoReduxAction {
        return {
            type: ShoppingCartActionsV2.SET_CART_TERMS_AGREED,
            payload: { termsAgreed: termsAgreed },
        };
    }

    setStatus(status: string): RidangoReduxAction {
        return {
            type: ShoppingCartActionsV2.SET_CART_STATUS,
            payload: status,
        };
    }

    hydrateCartState(cart: any): RidangoReduxAction {
        return {
            type: ShoppingCartActionsV2.HYDRATE_CART_STATE,
            payload: cart,
        };
    }
}
